<div class="container-sm-fluid pt-3 px-sm-4">
    <dx-tabs
        keyExpr="id"
        [items]="tabs"
        [(selectedItemKeys)]="selectedTabKeys"
        [showNavButtons]="false"
        stylingMode="primary"
    ></dx-tabs>
</div>

@if (selectedTabKeys[0] === 0) {
    <app-facility-utilization-score></app-facility-utilization-score>
} @else if (selectedTabKeys[0] === 1) {
    <app-facility-utilization></app-facility-utilization>
} @else if (selectedTabKeys[0] === 2) {
    <app-counts-per-storage-type></app-counts-per-storage-type>
} @else if (selectedTabKeys[0] === 3) {
    <app-counts-per-pallet-type></app-counts-per-pallet-type>
}
